<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="product_sn" placeholder="请扫SN码" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>
    <StationInfo ref="info" :bu-item="buItem"></StationInfo>
<!--------------------------------------展示测试工站信息-------------------------------------------------------------->
    <div v-if="showTestNg">
      <frame-form component-param="station_test_simple_readonly_repair" :init-data="testNgInfo"></frame-form>
    </div>

    <div style="display: flex">
    <span style="width: 140px;text-align: right;line-height: 35px;margin-top: 20px">配料信息</span>
    <el-row style="text-align: center;width: 80%;margin-left: 10px;margin-top: 20px">
      <el-col :span="5" class="title_class">物料编码</el-col>
      <el-col :span="7" class="title_class">物料描述</el-col>
      <el-col :span="3" class="title_class">库区</el-col>
      <el-col :span="3" class="title_class">物料数量</el-col>
      <el-col :span="5" class="title_class">库位</el-col>
      <el-col :span="1" class="title_class">
        <el-button size="small" icon="el-icon-plus" circle @click="addRow()"/>
      </el-col>
    </el-row>
    </div>

    <el-row v-for="materialInfo in materialInfoList" style="text-align: center;width: 80%;margin-left: 150px;margin-top: 10px">
      <el-col :span="5" >
        <el-cascader v-model="materialInfo.material_id" :options="materialWithCatalogList" @change="setMaterialName($event,materialInfo)"
                     style="padding-left: 5px;padding-right: 5px;" :show-all-levels="false" placeholder="请选择" :props="props" clearable filterable>
        </el-cascader>
      </el-col>
      <el-col :span="7" >
        <el-input v-model="materialInfo.material_name" style="padding-left: 5px;padding-right: 5px;" disabled></el-input>
      </el-col>
      <el-col :span="3" >
        <el-select v-model="materialInfo.area_type" @change="getMaterialStock" style="padding-left: 5px;padding-right: 5px;">
          <el-option v-for="item in materialTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option >
        </el-select>
      </el-col>
      <el-col :span="3" >
        <el-input-number v-model="materialInfo.repair_cnt" @change="getMaterialStock" min="0" style="width: 80%" :controls="false" ></el-input-number>
      </el-col>
      <el-col :span="5" >
        <el-select v-model="materialInfo.position_id" style="padding-left: 5px;padding-right: 5px;">
          <el-option v-for="item in materialInfo.positionList" :key="item.value" :label="item.label" :value="item.value"></el-option >
        </el-select>
      </el-col>
      <el-col :span="1" style="display: inline-flex;" >
        <div class="close" style="margin-left: 5px;" @click="removeRow(materialInfo.nanoid)">
          <el-icon size="24">
            <ElIconClose/>
          </el-icon>
        </div>
      </el-col>
    </el-row>

    <div style="margin: 10px 0 0 8px" v-if="showForm">
      <FrameForm ref="frameForm" :component-param="componentParam"
                 :parent-data="buItem" :init-data="initData"></FrameForm>
    </div>


  </div>
</template>

<script>


import StationInfo from "@/views/applications/station/StationInfo.vue";
import {nanoid} from "nanoid";

export default {
  name: "StationBatchingNoCenter",
  components: {StationInfo},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  provide() {
    return {
      $fn: {
        reset: () => {
          this.product_sn = ''
          this.reset();
        }
      }
    }
  },
  computed: {
    materialTypeList() {
      return this.$store.getters['core/getDictList']('wms_area_type');
    },
  },

  data() {
    return {
      loading:false,
      product_sn: '',
      buItem:{},
      materialInfoList:[],
      materialList:[],
      materialWithCatalogList:[],
      showForm:true,
      initData:{},
      showTestNg:false,
      testNgInfo:{},

      props: {
        emitPath:false,
        expandTrigger: 'hover',
        value: 'value',
        label: 'label'
      },

    }
  },

  async created() {
    await this.getMaterialList();
    await this.addTwoLine();
  },

  methods: {
    async search() {
      this.reset()

      this.$refs.frameForm.formInfo = {} //清空作业表单内容
      this.$refs.frameForm.clearMessage()
      if (this.$refs.frameForm.reset) {
        this.$refs.frameForm.reset()
      }


      if (!this.product_sn){
          return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      await this.$http('buItemSimpleService.queryStationInfo', {
        station_id: 'batching_not_center',
        product_sn: this.product_sn
      }, false).then(async data => {
        this.loading = false
        this.buItem = data.buItem || {}
        this.buItem.station_id = 'batching_not_center'
        return this.$refs.searchMessage.showSuccess('状态正常，请作业');
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      });
      await this.getMaterialList();
      await this.getTestNgInfo();
    },
    reset() {
      this.buItem = {}
      this.materialInfoList = [];
      this.$refs.searchMessage.clear()
      this.addRow();
    },

    //获取物料
    async getMaterialList() {
      if(this.buItem?.product_id === undefined){
        this.materialWithCatalogList = await this.$http('baseMaterialService.getMaterialWithCatalogShowId',{});
      }else {
        this.materialWithCatalogList = await this.$http('baseProductService.getBomMaterialByProductId',{product_id:this.buItem.product_id});
      }
      this.materialList = await this.$http('baseMaterialService.getAllMaterial',{});
    },
    setMaterialName(value,item) {
      if (value !== undefined) {
        for (let material of this.materialList) {
          if (material.id === value) {
            item.material_name = material.name;
            break;
          }
        }
      }else {
        item.material_name = '';
      }
      this.getMaterialStock();
    },

    showTooltip(name){
      if(name !== undefined){
        return name.length > 10;
      }
        return false;
    },

    //获取库存信息
    async getMaterialStock(){
      let params = {
        materialInfoList:this.materialInfoList,
      }
      this.materialInfoList = await this.$http('buItemSimpleService.getMaterialStockList',params);

      this.initData.materialList = this.materialInfoList;
      await this.$refs.frameForm.initForm();
    },
    //获取是否有测试工站信息
    async getTestNgInfo(){
      if(this.buItem.id !== undefined){
        let params = {
          itemId: this.buItem.id,
        }
        this.testNgInfo = await this.$http('buItemSimpleService.getTestNgInfo',params);
        if(this.testNgInfo.id !== undefined){
          this.showTestNg = true;
        }
      }
    },

    async addTwoLine(){
      await this.addRow();
      await this.addRow();
    },

    //添加行
    addRow(){
      if(this.materialInfoList.length === 0){
        this.materialInfoList = []
        this.materialInfoList.push({
          nanoid: nanoid(),
          material_id:'',
          material_type:'',
        })
      }else {
        this.materialInfoList.push({
          nanoid: nanoid(),
          material_id:'',
          material_type:'',
        })
      }
    },

    //删除行
    removeRow(nanoid){
      if(this.materialInfoList.length === 1){
        return;
      }
      this.materialInfoList = this.materialInfoList.filter(item => item.nanoid !== nanoid)

    }
  }
}
</script>

<style scoped>

.title_class{
  margin-bottom: 5px;
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.close {
  width: 35px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
}


.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

</style>